// #region: Class definition *********************************************************************/
/**
 * Manages window objects (iFrame) within the system.
 */
window.windowManager = new class {

    /**
     * Declare top level application classes and variables as local variables in another (nested) window/iframe.
     * This way, authors can address e.g. leanformsNext.onAjaxError as such instead of top.leanformsNext.onAjaxError
     * @param {DocumentView} win                The Window (iframe) to add the top reference to.
     */
    /* eslint-disable-next-line class-methods-use-this -- Cannot use/access static methods within an anonymous class expression. */
    declareTopLocal(win) {
        const topLevelList = [
            "application",
            "applicationHub",
            "broadcasts",
            "confirm",
            "confirmToast",
            "core",
            "coreUI",
            "dating",
            "eventBroadcaster",
            "leanformsNext",
            "menu",
            "messages",
            "questionControllerRegistry",
            "resources",
            "signalR",
            "tabstrip",
            "toast",
            "topWindow",
            "validation",
            "validator",
            "windowManager"
        ];

        topLevelList.forEach((name) => {
            if (topWindow[name]) {
                win[name] = topWindow[name];
            }
        });
    }

    // #region: Build ****************************************************************************/
    /**
     * Identifies class.
     * @returns {String}                        The string representation of this class.
     */
    toString() {
        return "[windowManager]";
    }

    static toString() {
        return "[windowManager]";
    }

    /** 
     * Identifies the version.
     * @returns {String}                        The version number of this class.
     */
    static version() {
        return "1.0.0";
    }
    // #endregion ********************************************************************************/
}();
// #endregion ************************************************************************************/